import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './lang'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import download from '@/utils/download'

import VideoPlayer from 'vue-video-player/src'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import { isMobile } from '@/utils/device'
Vue.prototype.$isMobile = isMobile()
Vue.prototype.$download = download
Vue.use(ElementUI);

Vue.use(VideoPlayer)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n, // 注入全局
  render: h => h(App)
}).$mount('#app')
